import { useMemo } from 'react';
import { useTranslation } from '@blocs.i18n';

export const useValidationMessages = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      EMPTY_FIELD_ERROR: t('common:claimAdditionalAccounts.validation.required'),
      MAX_NUMBERS_CLAIMED_ACC: t('common:claimAdditionalAccounts.validation.maxClaimed'),
      UNABLE_TO_RESTORE_ACCOUNT_MSG: t('common:claimAdditionalAccounts.validation.unableToRestore'),
      ALREADY_CLAIMED: t('common:claimAdditionalAccounts.validation.alreadyClaimed'),
    }),
    [t]
  );
};
